export type SmartPickKey = 'budget' | 'battery' | 'camera' | 'compact'

export interface SmartPickBrowsePreset {
  q: string
}

export interface SmartPickDef {
  key: SmartPickKey
  preset: SmartPickBrowsePreset
  titleKey: string
  subtitleKey: string
  gradient: string
  mobileBg: string
}

/** Hero imagery for smart-pick tiles (served from /smart-picks/ on web). */
const SMART_PICK_IMAGE: Record<SmartPickKey, string> = {
  budget: '/smart-picks/budget.png',
  battery: '/smart-picks/battery.png',
  camera: '/smart-picks/camera.png',
  compact: '/smart-picks/compact.png',
}

const SMART_PICK_ORIGIN = 'https://redevicer.com'

export const SMART_PICKS: SmartPickDef[] = [
  {
    key: 'budget',
    preset: { q: 'Galaxy A' },
    titleKey: 'vc.rail.smart.budgetTitle',
    subtitleKey: 'vc.rail.smart.budgetSub',
    gradient: 'linear-gradient(155deg,#fff7ed 0%,#ffedd5 55%,#fed7aa 100%)',
    mobileBg: '#ffedd5',
  },
  {
    key: 'battery',
    preset: { q: 'battery' },
    titleKey: 'vc.rail.smart.batteryTitle',
    subtitleKey: 'vc.rail.smart.batterySub',
    gradient: 'linear-gradient(155deg,#faf5ff 0%,#ede9fe 50%,#c4b5fd 100%)',
    mobileBg: '#ede9fe',
  },
  {
    key: 'camera',
    preset: { q: 'Pro' },
    titleKey: 'vc.rail.smart.cameraTitle',
    subtitleKey: 'vc.rail.smart.cameraSub',
    gradient: 'linear-gradient(155deg,#ecfdf5 0%,#d1fae5 50%,#6ee7b7 100%)',
    mobileBg: '#d1fae5',
  },
  {
    key: 'compact',
    preset: { q: 'mini' },
    titleKey: 'vc.rail.smart.compactTitle',
    subtitleKey: 'vc.rail.smart.compactSub',
    gradient: 'linear-gradient(155deg,#f8fafc 0%,#e2e8f0 50%,#94a3b8 100%)',
    mobileBg: '#e2e8f0',
  },
]

function inBrowser(): boolean {
  return typeof globalThis !== 'undefined' && 'document' in globalThis
}

export function getSmartPickImageUrl(key: SmartPickKey): string {
  const path = SMART_PICK_IMAGE[key]
  if (path.startsWith('http')) return path
  if (inBrowser()) return path
  return `${SMART_PICK_ORIGIN}${path}`
}

export function findSmartPickByQuery(q: string): SmartPickDef | undefined {
  const needle = q.trim()
  if (!needle) return undefined
  return SMART_PICKS.find((p) => p.preset.q === needle)
}
